export class UIDTermsSceneController {
    hide() {
        this.termsSceneContainerDiv.classList.add('hidden');
    }
    show() {
        this.termsSceneContainerDiv.classList.remove('hidden');
        this.sidebarController.deactivateAllButtons();
    }
    constructor(sidebarController){
        this.sidebarController = sidebarController;
        this.termsSceneContainerDiv = document.getElementById('scene_discord_terms_container');
    }
}
